import { Box, Link, Stack, styled, Typography } from '@mui/material';
import { AutomationListVariant } from '../enums';
import { AutomationListVariantType } from '../types';

export const getAutomationDropdownSx = (theme) => ({
  '& .MuiInputBase-root': {
    height: theme.spacing(5.25),
  },
  '& .MuiInputBase-input': {
    backgroundColor: 'white !important',
    padding: `${theme.spacing(1.25)} ${theme.spacing(1.75)}`,
    borderRadius: theme.spacing(1.25),
  },
  margin: `0 ${theme.spacing(1)}`,
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  borderColor: theme.palette.border.main,
  borderRadius: theme.spacing(1.25),
});

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  paddingTop: theme.spacing(1),
}));

export const AddAnotherAutomationButton = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  paddingTop: theme.spacing(2.5),
}));

export const AutomationAnswer = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));

export const AutomationContainer = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: theme.shape.borderRadius * 2,
  gap: theme.spacing(1.25),
  marginBottom: theme.spacing(2),
  width: '100%',
}));

export const AutomationDetail = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  paddingLeft: theme.spacing(1.5),
}));

export interface ListProps {
  listVariant: AutomationListVariantType;
}

export const AutomationQuestionText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'listVariant',
})<ListProps>(({ theme, listVariant }) => ({
  borderBottom:
    listVariant === AutomationListVariant.READ_ONLY
      ? `1px solid ${theme.palette.border.main}`
      : null,
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  padding:
    listVariant === AutomationListVariant.READ_ONLY
      ? `${theme.spacing(2)} ${theme.spacing(3)}`
      : theme.spacing(2),
}));

export const AutomationStatusChipContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'left',
  listStyle: 'none',
});

export const BoldText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));

export const IndividualAutomationContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.fill.lightest,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 1,
  padding: theme.spacing(2),
}));

export const ListItemContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'listVariant',
})<ListProps>(({ theme, listVariant }) => ({
  backgroundColor: listVariant === AutomationListVariant.READ_ONLY ? '#fbfbfb' : 'inherit',
  borderRadius: theme.spacing(1),
  color: theme.palette.text.primary,
  padding:
    listVariant === AutomationListVariant.READ_ONLY
      ? `${theme.spacing(2)} ${theme.spacing(2)} 0 ${theme.spacing(3)}`
      : `0 ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)}`,
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
}));

export const ModalPaneContainer = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  paddingTop: theme.spacing(2.5),
}));

export const Subtitle = styled(Box)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));
